import { type IconName } from '@projectTypes/icon-name'
import React from 'react'
import { type SVGProps } from 'react'

import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function classNames(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function Icon({
  name,
  childClassName,
  className,
  children,
  ...props
}: SVGProps<SVGSVGElement> & {
  name: IconName
  childClassName?: string
}) {
  if (children) {
    return (
      <span
        className={classNames(
          `font inline-flex items-center gap-1.5`,
          childClassName
        )}
      >
        <Icon name={name} className={className} {...props} />
        {children}
      </span>
    )
  }
  return (
    <svg
      {...props}
      className={classNames('inline size-4 self-center', className)}
    >
      <use xlinkHref={`/icons/sprite-aqKZtEZNdt.svg#${name}`} />
    </svg>
  )
}

export { IconName }
